import ProductSlider from "../lib/slider/product-slider";
import Page from "../common/page";
import {CustomEventHandler} from "../utils/CustomEventHandler";
import {CUSTOM_SCROLL} from "../common/globalVars";
import SiteData from '/setting/site-data';
import * as Item from '/src/ejs/component/component-product-all-item.ejs';
import Header from "../common/header";
import {HtmlUtil} from "../utils/HtmlUtil";

export default class PageProductList extends Page {
    setPage() {
        window.productListSubY = [];
        this.setNewProduct(this.data.page.data.new_best.main.product);

        this.productSliders = [
            new ProductSlider(this.el.querySelector('.sec-3'), this.data.page.data.new_best.product_slider),
            new ProductSlider(this.el.querySelector('.sec-5'), this.data.page.data.calibrator.product_slider),
            new ProductSlider(this.el.querySelector('.sec-7'), this.data.page.data.serum.product_slider),
            new ProductSlider(this.el.querySelector('.sec-9'), this.data.page.data.cream.product_slider),
            new ProductSlider(this.el.querySelector('.sec-11'), this.data.page.data.eyecare.product_slider),
            new ProductSlider(this.el.querySelector('.sec-13'), this.data.page.data.toner_emulsion.product_slider),
            new ProductSlider(this.el.querySelector('.sec-15'), this.data.page.data.cleanser.product_slider),
            new ProductSlider(this.el.querySelector('.sec-17'), this.data.page.data.special_care.product_slider),
            new ProductSlider(this.el.querySelector('.sec-19'), this.data.page.data.cushion.product_slider),
        ];

        this.currentSub = -1;
        this.productSubIds = SiteData.productCategory;
        this.productSubY = [];

        this.setProductSubY();
        this.setProductSubFocus({detail:0});
        this.setAllProduct();

        CustomEventHandler.addHandler(window, 'resize', (e)=>{
            this.setProductSubY();
        });

        CustomEventHandler.addHandler(window, CUSTOM_SCROLL, (e)=>{
            this.setProductSubFocus(e);
        });
    }


    setPushArray(parentArray, dataArray) {
        dataArray.forEach((data) => {
            parentArray.push(data);
        })
    }

    setAllProduct() {
        this.productAllData = [];
        this.setPushArray(this.productAllData, this.data.page.data.prestige.product_slider);
        this.setPushArray(this.productAllData, this.data.page.data.calibrator.product_slider);
        this.setPushArray(this.productAllData, this.data.page.data.serum.product_slider);
        this.setPushArray(this.productAllData, this.data.page.data.cream.product_slider);
        this.setPushArray(this.productAllData, this.data.page.data.eyecare.product_slider);
        this.setPushArray(this.productAllData, this.data.page.data.toner_emulsion.product_slider);
        this.setPushArray(this.productAllData, this.data.page.data.cleanser.product_slider);
        this.setPushArray(this.productAllData, this.data.page.data.special_care.product_slider);
        this.setPushArray(this.productAllData, this.data.page.data.cushion.product_slider);

        let i=0;
        // console.log('---->');
        const listEl = this.el.querySelector('.sec-21 .product-container')
        // console.log(listEl);

        console.log(this.productAllData);
        this.productAllData.forEach((data)=> {
            let element = HtmlUtil.getEjsElement(Item(), data);
            // console.log(element);
            listEl.appendChild(element);
        })
    }


    setNewProduct(productData) {
        let el = this.el.querySelector('.sec-1 .item-info-holder');
        el.querySelector('figure img').src = productData.img;
        el.querySelector('article span').innerHTML = productData.sub_title;
        el.querySelector('article strong').innerHTML = productData.title;
        el.querySelector('article p').innerHTML = productData.desc;
        el.querySelector('a').href = productData.link;
    }

    setProductSubY() {
        // console.log('resize');
        let idx = 0;
        this.productSubIds.forEach((data)=> {
            if (document.querySelector('#' + data.hash)) {
                window.productListSubY[idx] = this.productSubY[idx] = document.querySelector('#' + data.hash).offsetTop;
                idx++;
            }
        })
    }

    setProductSubFocus(e) {
        let idx = 0;
        let tmpCurrentSub;
        this.productSubY.forEach((y)=>{
            if ((e.detail +window.innerHeight) > y) {
                tmpCurrentSub = idx;
            }
            idx ++;
        })

        // console.log(tmpCurrentSub + ' ');
        if (tmpCurrentSub === undefined) return;

        // if (tmpCurrentSub !== this.currentSub) {
            this.currentSub = tmpCurrentSub;
            new Header().setProductFocus(this.currentSub);
        // }
    }

}
